import "phaser";
import "howler";

import { Game } from "./Game";
import { GameConstants } from "./GameConstants";
import { BootScene } from "./scenes/BootScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { BoardScene } from "./scenes/board-scene/BoardScene";
import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";
import { SplashScene } from "./scenes/splash-scene/SplashScene";
import { ShopScene } from "./scenes/shop-scene/ShopScene";
import { TutorialScene } from "./scenes/instructions-scene/TutorialScene";
import { MatchingScene } from "./scenes/matching-scene/MatchingScene";

let game: Game;

declare var gamezop: any;
window.onload = () => {

    let isMobile: any = navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i);
        
    // due to an issue with the new iPad Air
    if ((navigator.platform === "MacIntel" && navigator.maxTouchPoints > 0) || navigator.platform === "iPad") {
        isMobile = true;
    }

    const gameConfig = {

        version: GameConstants.VERSION,
        type: Phaser.CANVAS,
        backgroundColor: "CCCCCC",
        dom: {
            createContainer: true
        },
       
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            parent: "content",
            width: GameConstants.GAME_WIDTH,
            height: GameConstants.GAME_HEIGHT
            
        },
        scene:  [
                    BootScene, 
                    PreloadScene, 
                    SplashScene,
                    ShopScene,
                    TutorialScene,
                    BoardScene,
                    MatchingScene
                ]
    };

    game = new Game(gameConfig);

   /*  if (isMobile) {
        setInterval(() => {
            checkOriention();
        }, 75);
    } else {
        window.addEventListener("resize", resize, false);
    }

    window.focus();
    resize(); */

    window.onerror = function (msg, url, lineNo, columnNo, error) {
        
        if (msg === "Uncaught Error: bad checksum") {
            return true;
        } else {
            return false;
        }
    };
};

/* function resize(): void {

    const canvas = document.querySelector("canvas");
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const windowRatio = windowWidth / windowHeight;

    const gameWidth: any = game.config.width;
    const gameHeight: any = game.config.height;

    const gameRatio = gameWidth / gameHeight;
    
    if (windowRatio < gameRatio) {
        canvas.style.width = windowWidth + "px";
        canvas.style.height = (windowWidth / gameRatio) + "px";
    } else {
        canvas.style.width = (windowHeight * gameRatio) + "px";
        canvas.style.height = windowHeight + "px";
    }
  // onOrientationChange(true);
}

function checkOriention(): void {

    const w = window.innerWidth;
    const h = window.innerHeight;

    if (w < h) {

        if (!GameVars.intitialised) {
            GameManager.init(); 
        }

        document.getElementById("orientation").style.display = "none";
        document.getElementById("content").style.display = "block";

    } else {
        document.getElementById("orientation").style.display = "block";
        document.getElementById("content").style.display = "none";
    }
} */
